<div class="flex flex-row full-grow-no-shrink-no-basis" cdkDropListGroup>
    <mat-sidenav-container *ngIf="true" class="full-grow-no-shrink-no-basis" [autosize]="true"
                           style="background-color: white;">
        <mat-sidenav [opened]="true" [disableClose]="true" mode="side">
            <lib-elite-form-designer-left-sidebar [enableQnrFieldImport]="selectedTab.tabData['EnableQnrFieldImport']"
                                                  [isQnrSet]="isQnrSet" [isCollapsed]="true"
                                                  [sourceType]="selectedTab.tabData['SourceType']"
                                                  [flowchartId]="flowchartId"></lib-elite-form-designer-left-sidebar>
        </mat-sidenav>
        <app-elite-form-canvas-design-container [eliteformId]="eliteformId"></app-elite-form-canvas-design-container>
    </mat-sidenav-container>
</div>
